const getGraphqlErrorMessage = (graphqlErrors: any) => {
  const errorMessages: any = [];
  graphqlErrors.forEach((error: any) => {
    if (error.extensions.code === "OUTPAVE_CUSTOM_ERROR") {
      errorMessages.push(error.message);
    } else {
      errorMessages.push("Something went wrong!");
    }
  });
  return errorMessages.length > 0 ? errorMessages.join("\n") : "";
};

export { getGraphqlErrorMessage };
